import axios from "axios";
import {logoutApp} from '../contexts/GlobalProviders';
import {getToken} from './storage';
import localforage from "./localforage";
//import fbConfig from "./fbConfig";

const history = {
    push: (path) => window.history.pushState('', '', path)
}


let http = axios.create({
    baseURL: process.env.API,
});


http.interceptors.request.use(async config => {
    config.headers['Google-Token'] = getToken()?.token;
    let ld = await localforage.getItem('liderado');
    if(ld && ld.codigoLiderado){
        config.headers['Liderado'] = ld.codigoLiderado;
    } else {
        config.headers['Liderado'] = '';
    }
    
    // let credential = await localforage.getItem('credential');
    // const gProv = new firebase.auth.GoogleAuthProvider()
    // gProv.setCustomParameters({client_id: fbConfig.clientId})
    // console.log(credential = gProv.credential(credential.Zi.id_token, credential.Zi.access_token))
    // firebase.auth().signInWithCredential(credential).then((...a) => console.log('auth', a))
    return config;
});
http.interceptors.response.use(null, async (error) => {
    if (error?.response?.status === 401) {
        logoutApp(history);
        window.alert('Você foi desconectado por inatividade. \nSua sessão expirou.');
        /*await firebase.auth().currentUser.getIdToken(true)
        .then(function(idToken) {
            error.config.headers['Google-Token'] = idToken;
        }).catch(function(error) {
            return http.request(error.config)
        });*/
    }
    return Promise.reject(error);
});
export default http;
